import type { IconDef } from '../types';

// The bare checkmark (Figma "Stroke 1"), identical to the check cut out of
// `tick-with-container` — kept in the same 24×24 frame so the two read as one
// glyph whether drawn positive (checkbox) or as the disc cut-out (radio).
export const check: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M18.9717 8.17969C18.6695 7.84415 18.1522 7.81725 17.8164 8.11914L10.4834 14.7178L7.0918 11.6787C6.75535 11.3772 6.23811 11.4059 5.93652 11.7422C5.63525 12.0786 5.66294 12.5959 5.99902 12.8975L9.93848 16.4277C10.2496 16.7065 10.7216 16.706 11.0322 16.4268L18.9111 9.33594C19.247 9.03366 19.2739 8.51556 18.9717 8.17969Z',
    },
  ],
};
